import React, { FC, CSSProperties } from 'react';
import classnames from 'classnames';
import { ITooltipProps } from './type';

export const BaseTooltip: FC<ITooltipProps> = ({
  position,
  children,
  width = 'auto',
  wrapperClassName,
  tooltipRef,
  style,
}) => {
  const styles: CSSProperties = { width, ...style };
  if (position) {
    styles.top = `${position.y}px`;
    styles.left = `${position.x}px`;
  }

  const classes = classnames('fixed', wrapperClassName);

  return (
    <div style={styles} className={classes} ref={tooltipRef}>
      {children}
    </div>
  );
};
